// Pure validation rules for Administration > Organisation > Organisation
// Details, kept apart from the screen so they can be unit tested without
// rendering it. Contact rules live with the Contacts page
// (pages/Administration/Organisation/organisationContactsRules).

// Page-level rules checked on Save Changes.
export const validateOrganisation = (form) => {
  const errors = {};

  if (!form.organisationId?.trim()) {
    errors.organisationId = "Organisation ID is required.";
  }
  if (!form.organisationName?.trim()) {
    errors.organisationName = "Organisation name is required.";
  }

  return errors;
};
